import { useCallback, useMemo, useState } from 'react';

import type { ValueList, ValueLists } from '@ohpen/enso-ui';
import { ActionEntityType } from '@pmp/api';

import { readKnownQualifiedDomains, rememberQualifiedDomains } from './qualifiedDomains';

export const QUALIFIED_DOMAINS_LIST = 'qualifiedDomains';

export const useQualifiedDomainsInCR = (
  entityType: ActionEntityType | null,
  dataSource: readonly unknown[] | null,
): { valueLists: ValueLists; rememberDomains: (value: unknown) => void } => {
  const isLenderFirms = entityType === ActionEntityType.LENDER_FIRMS;
  const [storedDomains, setStoredDomains] = useState<string[]>(readKnownQualifiedDomains);

  const rememberDomains = useCallback((value: unknown) => {
    if (!Array.isArray(value)) return;
    setStoredDomains(rememberQualifiedDomains(value.map(String)));
  }, []);

  return useMemo<{ valueLists: ValueLists; rememberDomains: (value: unknown) => void }>(() => {
    const noSuggestions: ValueLists = {};
    if (!isLenderFirms) return { valueLists: noSuggestions, rememberDomains };

    const inUse = (dataSource ?? []).flatMap(row => {
      const domains = (row as { qualifiedDomains?: unknown }).qualifiedDomains;
      return Array.isArray(domains) ? domains.map(String) : [];
    });
    const suggestions: ValueList = {};
    [...storedDomains, ...inUse].filter(Boolean).forEach(domain => {
      suggestions[domain] = domain;
    });

    return { valueLists: { [QUALIFIED_DOMAINS_LIST]: suggestions }, rememberDomains };
  }, [isLenderFirms, dataSource, storedDomains, rememberDomains]);
};
